import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "weekdays-list"
}
const _hoisted_2 = { class: "schedule-list" }

import { onMounted, reactive } from 'vue';
import { getUsualScheduleSubpage } from './apiMethods';
import { GetStudentUsualScheduleSubpageResponseModel } from './UsualScheduleSubpage.types';
import { WeekDays } from '@/models/ScheduleLists/WeekDaysEnum';
import expansionPanel from '@/common/components/snedson-material-components/expansion-panel/expansion-panel.vue';
import universalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import timerIcon from '@/assets/icons/emojis/time.png';
import schoolIcon from '@/assets/icons/emojis/school.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import bellIcon from '@/assets/icons/emojis/bell.png';
import { getWeekdayTitle } from '@/helpers/getWeekdayTitle';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsualScheduleSubpage',
  setup(__props) {

const state = reactive<{
    data: GetStudentUsualScheduleSubpageResponseModel | null;
}>({ data: null });

onMounted(() => {
    getUsualScheduleSubpage().then((res) => {
        state.data = res.data;
        console.log(res.data);
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(state.data.uses.usEsForClass), (day) => {
          return (_openBlock(), _createBlock(expansionPanel, {
            key: day[0],
            props: { title: _unref(getWeekdayTitle)(day[0] as WeekDays) }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day[1], (use) => {
                  return (_openBlock(), _createBlock(universalCard, {
                    key: use.num,
                    props: {
                        type: 'filled',
                        title: `${use.num}. ${use.subjectFullName}`,
                        icon: _unref(getBaseUrl)() + use.iconURL,
                        dataTags: [
                            {
                                iconCompleteUrl: _unref(timerIcon),
                                title: `${
                                    state.data.usps.usPs[day[0]][use.num - 1]
                                        .begin
                                } - ${
                                    state.data.usps.usPs[day[0]][use.num - 1]
                                        .end
                                } (${
                                    state.data.usps.usPs[day[0]][use.num - 1]
                                        .durationInMins
                                } мин.)`,
                                color: 'var(--snotra--sys--surface-variant)',
                            },
                            {
                                iconCompleteUrl: _unref(schoolIcon),
                                color: 'var(--snotra--sys--surface-variant)',
                                title: use.location,
                            },
                            {
                                iconCompleteUrl: _unref(studentIcon),
                                color: 'var(--snotra--sys--surface-variant)',
                                title: use.groupName
                                    ? use.groupName
                                    : 'Весь класс ',
                            },
                            {
                                iconCompleteUrl: _unref(bellIcon),
                                color: 'var(--snotra--sys--surface-variant)',
                                title: `Перемена после: ${
                                    state.data.usps.usPs[day[0]][use.num - 1]
                                        .breakDurationInMins
                                } мин.`,
                            },
                        ],
                    },
                    class: _normalizeClass(use.colorSchemeName)
                  }, null, 8, ["props", "class"]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["props"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})